import styled from "styled-components";

export const VehicleCheckedInContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`;
